<a
    class="relative w-8 h-8 rounded-lg p-1.5 overflow-hidden bg-blurple-dark"
    routerLink="/dashboard">
    <img [src]="'../../../../assets/images/logo.svg'" alt="Focusmate Logo" class="w-full h-full" />
</a>
